// extracted by mini-css-extract-plugin
export default {"content":"Sustainability_content__2y67R"};